import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPackageQueryVariables = GraphQLTypes.Exact<{
  id: GraphQLTypes.Scalars['String'];
}>;


export type GetPackageQueryResult = (
  { __typename?: 'Query' }
  & { getPackage?: GraphQLTypes.Maybe<(
    { __typename?: 'Package' }
    & Pick<GraphQLTypes.Package, 'id' | 'packageName' | 'netTotal' | 'createdAt' | 'startDate' | 'endDate' | 'total'>
    & { createdBy?: GraphQLTypes.Maybe<(
      { __typename?: 'Admin' }
      & Pick<GraphQLTypes.Admin, 'id' | 'firstName' | 'lastName'>
    )>, customerPayment?: GraphQLTypes.Maybe<(
      { __typename?: 'PackagePayment' }
      & Pick<GraphQLTypes.PackagePayment, 'id' | 'notes'>
      & { deposit?: GraphQLTypes.Maybe<(
        { __typename?: 'PaymentType' }
        & Pick<GraphQLTypes.PaymentType, 'date' | 'amount' | 'paid' | 'remaining'>
      )>, total?: GraphQLTypes.Maybe<(
        { __typename?: 'PaymentType' }
        & Pick<GraphQLTypes.PaymentType, 'date' | 'amount' | 'paid' | 'remaining'>
      )>, payments?: GraphQLTypes.Maybe<Array<GraphQLTypes.Maybe<(
        { __typename?: 'Transaction' }
        & Pick<GraphQLTypes.Transaction, 'id' | 'date' | 'amount' | 'bank' | 'type' | 'code'>
      )>>> }
    )>, customer?: GraphQLTypes.Maybe<(
      { __typename?: 'Customer' }
      & Pick<GraphQLTypes.Customer, 'id' | 'firstName' | 'lastName'>
    )>, hotels: Array<(
      { __typename?: 'HotelPackage' }
      & Pick<GraphQLTypes.HotelPackage, 'id' | 'checkIn' | 'checkOut' | 'total' | 'children' | 'childrenAge' | 'adults' | 'extra' | 'view' | 'board' | 'notes' | 'roomType' | 'infants'>
      & { hotel?: GraphQLTypes.Maybe<(
        { __typename?: 'Hotel' }
        & Pick<GraphQLTypes.Hotel, 'id' | 'name' | 'phone'>
      )>, partnerPayment?: GraphQLTypes.Maybe<(
        { __typename?: 'PackagePayment' }
        & Pick<GraphQLTypes.PackagePayment, 'id' | 'notes'>
        & { deposit?: GraphQLTypes.Maybe<(
          { __typename?: 'PaymentType' }
          & Pick<GraphQLTypes.PaymentType, 'date' | 'amount' | 'paid' | 'remaining'>
        )>, total?: GraphQLTypes.Maybe<(
          { __typename?: 'PaymentType' }
          & Pick<GraphQLTypes.PaymentType, 'date' | 'amount' | 'paid' | 'remaining'>
        )>, payments?: GraphQLTypes.Maybe<Array<GraphQLTypes.Maybe<(
          { __typename?: 'Transaction' }
          & Pick<GraphQLTypes.Transaction, 'id' | 'date' | 'amount' | 'bank' | 'type' | 'code'>
        )>>> }
      )>, partner?: GraphQLTypes.Maybe<(
        { __typename?: 'Partner' }
        & Pick<GraphQLTypes.Partner, 'id' | 'name'>
      )> }
    )>, extras: Array<(
      { __typename?: 'ExtraPackage' }
      & Pick<GraphQLTypes.ExtraPackage, 'id' | 'name' | 'total' | 'notes'>
      & { partnerPayment?: GraphQLTypes.Maybe<(
        { __typename?: 'PackagePayment' }
        & Pick<GraphQLTypes.PackagePayment, 'id' | 'notes'>
        & { deposit?: GraphQLTypes.Maybe<(
          { __typename?: 'PaymentType' }
          & Pick<GraphQLTypes.PaymentType, 'date' | 'amount' | 'paid' | 'remaining'>
        )>, total?: GraphQLTypes.Maybe<(
          { __typename?: 'PaymentType' }
          & Pick<GraphQLTypes.PaymentType, 'date' | 'amount' | 'paid' | 'remaining'>
        )>, payments?: GraphQLTypes.Maybe<Array<GraphQLTypes.Maybe<(
          { __typename?: 'Transaction' }
          & Pick<GraphQLTypes.Transaction, 'id' | 'date' | 'amount' | 'bank' | 'type' | 'code'>
        )>>> }
      )> }
    )>, transfers: Array<(
      { __typename?: 'TransferPackage' }
      & Pick<GraphQLTypes.TransferPackage, 'id' | 'company' | 'total' | 'notes' | 'dates'>
      & { partner?: GraphQLTypes.Maybe<(
        { __typename?: 'Partner' }
        & Pick<GraphQLTypes.Partner, 'id' | 'name'>
      )>, partnerPayment?: GraphQLTypes.Maybe<(
        { __typename?: 'PackagePayment' }
        & Pick<GraphQLTypes.PackagePayment, 'id' | 'notes'>
        & { deposit?: GraphQLTypes.Maybe<(
          { __typename?: 'PaymentType' }
          & Pick<GraphQLTypes.PaymentType, 'date' | 'amount' | 'paid' | 'remaining'>
        )>, total?: GraphQLTypes.Maybe<(
          { __typename?: 'PaymentType' }
          & Pick<GraphQLTypes.PaymentType, 'date' | 'amount' | 'paid' | 'remaining'>
        )>, payments?: GraphQLTypes.Maybe<Array<GraphQLTypes.Maybe<(
          { __typename?: 'Transaction' }
          & Pick<GraphQLTypes.Transaction, 'id' | 'date' | 'amount' | 'bank' | 'type' | 'code'>
        )>>> }
      )> }
    )>, tickets: Array<(
      { __typename?: 'TicketPackage' }
      & Pick<GraphQLTypes.TicketPackage, 'id' | 'numberOfPassengers' | 'company' | 'total' | 'notes'>
      & { departure: (
        { __typename?: 'DepartureDetails' }
        & Pick<GraphQLTypes.DepartureDetails, 'date' | 'reference'>
      ), return?: GraphQLTypes.Maybe<(
        { __typename?: 'ReturnDetails' }
        & Pick<GraphQLTypes.ReturnDetails, 'date' | 'reference'>
      )>, partner?: GraphQLTypes.Maybe<(
        { __typename?: 'Partner' }
        & Pick<GraphQLTypes.Partner, 'id' | 'name'>
      )>, partnerPayment?: GraphQLTypes.Maybe<(
        { __typename?: 'PackagePayment' }
        & Pick<GraphQLTypes.PackagePayment, 'id' | 'notes'>
        & { deposit?: GraphQLTypes.Maybe<(
          { __typename?: 'PaymentType' }
          & Pick<GraphQLTypes.PaymentType, 'date' | 'amount' | 'paid' | 'remaining'>
        )>, total?: GraphQLTypes.Maybe<(
          { __typename?: 'PaymentType' }
          & Pick<GraphQLTypes.PaymentType, 'date' | 'amount' | 'paid' | 'remaining'>
        )>, payments?: GraphQLTypes.Maybe<Array<GraphQLTypes.Maybe<(
          { __typename?: 'Transaction' }
          & Pick<GraphQLTypes.Transaction, 'id' | 'date' | 'amount' | 'bank' | 'type' | 'code'>
        )>>> }
      )> }
    )>, insurances: Array<(
      { __typename?: 'InsurancePackage' }
      & Pick<GraphQLTypes.InsurancePackage, 'id' | 'company' | 'total' | 'notes'>
      & { partnerPayment?: GraphQLTypes.Maybe<(
        { __typename?: 'PackagePayment' }
        & Pick<GraphQLTypes.PackagePayment, 'id' | 'notes'>
        & { deposit?: GraphQLTypes.Maybe<(
          { __typename?: 'PaymentType' }
          & Pick<GraphQLTypes.PaymentType, 'date' | 'amount' | 'paid' | 'remaining'>
        )>, total?: GraphQLTypes.Maybe<(
          { __typename?: 'PaymentType' }
          & Pick<GraphQLTypes.PaymentType, 'date' | 'amount' | 'paid' | 'remaining'>
        )>, payments?: GraphQLTypes.Maybe<Array<GraphQLTypes.Maybe<(
          { __typename?: 'Transaction' }
          & Pick<GraphQLTypes.Transaction, 'id' | 'date' | 'amount' | 'bank' | 'type' | 'code'>
        )>>> }
      )> }
    )> }
  )> }
);


export const GetPackageDocument = /*#__PURE__*/ gql`
    query getPackage($id: String!) {
  getPackage(id: $id) {
    id
    packageName
    netTotal
    createdAt
    startDate
    endDate
    createdBy {
      id
      firstName
      lastName
    }
    customerPayment {
      id
      deposit {
        date
        amount
        paid
        remaining
      }
      total {
        date
        amount
        paid
        remaining
      }
      payments {
        id
        date
        amount
        bank
        type
        code
      }
      notes
    }
    customer {
      id
      firstName
      lastName
    }
    total
    hotels {
      id
      checkIn
      checkOut
      total
      hotel {
        id
        name
        phone
      }
      partnerPayment {
        id
        deposit {
          date
          amount
          paid
          remaining
        }
        total {
          date
          amount
          paid
          remaining
        }
        payments {
          id
          date
          amount
          bank
          type
          code
        }
        notes
      }
      children
      childrenAge
      adults
      extra
      view
      total
      board
      notes
      roomType
      infants
      partner {
        id
        name
      }
    }
    extras {
      id
      name
      total
      notes
      partnerPayment {
        id
        deposit {
          date
          amount
          paid
          remaining
        }
        notes
        total {
          date
          amount
          paid
          remaining
        }
        payments {
          id
          date
          amount
          bank
          type
          code
        }
      }
    }
    transfers {
      id
      company
      total
      notes
      dates
      partner {
        id
        name
      }
      partnerPayment {
        id
        deposit {
          date
          amount
          paid
          remaining
        }
        total {
          date
          amount
          paid
          remaining
        }
        notes
        payments {
          id
          date
          amount
          bank
          type
          code
        }
      }
    }
    tickets {
      id
      departure {
        date
        reference
      }
      return {
        date
        reference
      }
      numberOfPassengers
      company
      partner {
        id
        name
      }
      partnerPayment {
        id
        notes
        deposit {
          date
          amount
          paid
          remaining
        }
        total {
          date
          amount
          paid
          remaining
        }
        payments {
          id
          date
          amount
          bank
          type
          code
        }
      }
      total
      notes
    }
    insurances {
      id
      company
      total
      notes
      partnerPayment {
        id
        notes
        deposit {
          date
          amount
          paid
          remaining
        }
        total {
          date
          amount
          paid
          remaining
        }
        payments {
          id
          date
          amount
          bank
          type
          code
        }
      }
      total
      notes
    }
  }
}
    `;

/**
 * __useGetPackageQuery__
 *
 * To run a query within a React component, call `useGetPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPackageQuery(baseOptions: Apollo.QueryHookOptions<GetPackageQueryResult, GetPackageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackageQueryResult, GetPackageQueryVariables>(GetPackageDocument, options);
      }
export function useGetPackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackageQueryResult, GetPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackageQueryResult, GetPackageQueryVariables>(GetPackageDocument, options);
        }
export type GetPackageQueryHookResult = ReturnType<typeof useGetPackageQuery>;
export type GetPackageLazyQueryHookResult = ReturnType<typeof useGetPackageLazyQuery>;